import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./i18n";

import "@aws-amplify/ui-vue";
import Amplify, { I18n } from "aws-amplify";
// @ts-ignore
import awsconfig from "./aws-exports";
Amplify.configure(awsconfig);

Vue.config.productionTip = false;

let languageDict = {
  ja: {
    "Sign in to your account": "サインイン",
    "Username ": "ユーザ名",
    "Enter your Username": "ユーザ名を入力してください",
    "Email Address *": "メールアドレス *",
    "Enter your email address": "メールアドレスを入力してください",
    "Password *": "パスワード *",
    "Enter your password": "パスワードを入力してください",
    "Forgot your password?": "パスワードを忘れた場合",
    "Reset password": "パスワードのリセット",
    "No account?": "まだアカウントをお持ちでない場合",
    "Have an account?": "アカウントをお持ちの場合",
    "Create a new account": "アカウントを作成する",
    "Sign In": "サインイン",
    "Sign in": "サインイン",
    "Create Account": "作成する",
    "Create account": "アカウント作成",
  },
};
I18n.putVocabularies(languageDict);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
